// Updated Cookies.jsx with backend integration
import { useEffect, useState } from "react";
import styles from "./Cookies.module.css";

import leftImg from "../assets/Cookie/Asset 29@2x.png";
import centerImg from "../assets/Cookie/Asset 31@2x.png";
import rightImg from "../assets/Cookie/Asset 30@2x.png";
import buttombord from "../assets/Cookie/Asset 22@2x.png";
import modalBg from "../assets/Cookie/Asset 25@2x.png";
import modalBgmobile from "../assets/form/Asset 6@2x.png";

import boardImg from "../assets/Cookie/Asset 27@2x.png";
import axios from "axios";


const API_URL = process.env.REACT_APP_API_URL || "https://server.junglemorals.com/api";

// Generate unique session ID
const getSessionId = () => {
  let sessionId = localStorage.getItem("sessionId");
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem("sessionId", sessionId);
  }
  return sessionId;
};


const getLocationFromIP = async (ip) => {
  try {
    // localhost pe real data nahi milta
    if (ip.includes("127.0.0.1") || ip.includes("localhost")) {
      return {
        city: "Localhost",
        country: "Localhost"
      };
    }

    const response = await axios.get(`https://ipapi.co/${ip}/json/`);

    return {
      city: response.data.city,
      country: response.data.country_name
    };
  } catch (error) {
    console.error("IP location error:", error.message);
    return {
      city: "Unknown",
      country: "Unknown"
    };
  }
};

const Cookies = () => {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  // Toggle states for cookies
  const [strictly, setStrictly] = useState(true);
  const [analytical, setAnalytical] = useState(false);
  const [advertising, setAdvertising] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (accepted) {
      setVisible(false);
      return;
    }

    const t = setTimeout(() => setOpen(true), 300);
    return () => clearTimeout(t);
  }, []);

  // Accept All Cookies
  const handleAccept = async () => {
    setShowModal(false);

    setTimeout(() => {
      setOpen(false);
    }, 100);

    setTimeout(async () => {
      localStorage.setItem("cookiesAccepted", "true");
      setVisible(false);

      // Backend mein save karo
      setLoading(true);
      try {
        const sessionId = getSessionId();
        const response = await fetch(`${API_URL}/cookies/accept-all`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-session-id": sessionId
          },
          body: JSON.stringify({ sessionId })
        });

        const data = await response.json();
        if (data.success) {
          console.log("✅ Cookie preferences saved");
        }
      } catch (error) {
        console.error("❌ Error saving cookies:", error);
      } finally {
        setLoading(false);
      }
    }, 1200);
  };

  // Reject All (Only Strictly Essential)
  const handleReject = async () => {
    setOpen(false);

    setTimeout(async () => {
      setVisible(false);

      // Backend mein save karo
      setLoading(true);
      try {
        const sessionId = getSessionId();
        const response = await fetch(`${API_URL}/cookies/reject-all`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-session-id": sessionId
          },
          body: JSON.stringify({ sessionId })
        });

        const data = await response.json();
        if (data.success) {
          console.log("✅ Only essential cookies saved");
        }
      } catch (error) {
        console.error("❌ Error saving cookies:", error);
      } finally {
        setLoading(false);
      }
    }, 1200);
  };

  const handleManagePreferences = () => {
    setShowModal(true);
  };

  // Save Custom Preferences
  const handleSavePreferences = async () => {
    setShowModal(false);

    const prefs = {
      strictly,
      analytical,
      advertising
    };

    localStorage.setItem("cookiePreferences", JSON.stringify(prefs));
    localStorage.setItem("cookiesAccepted", "true");

    // Backend mein save karo
    setLoading(true);
    try {
      const sessionId = getSessionId();
      const response = await fetch(`${API_URL}/cookies/preferences`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-session-id": sessionId
        },
        body: JSON.stringify({
          sessionId,
          strictly,
          analytical,
          advertising,
          acceptedAll: false,
          rejectedAll: false
        })
      });

      const data = await response.json();
      if (data.success) {
        console.log("✅ Custom preferences saved");

        // Cookie banner band karo
        setTimeout(() => {
          setOpen(false);
        }, 100);

        setTimeout(() => {
          setVisible(false);
        }, 1200);
      }
    } catch (error) {
      console.error("❌ Error saving preferences:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!visible) return null;

  return (
    <>
      <div className={styles.overlay}>
        <div className={styles.scrollContainer}> 
          <div className={`${styles.leftPiece} ${open ? styles.open : styles.closed}`}>
            <img src={leftImg} alt="" />
          </div>

          <div className={`${styles.centerPiece} ${open ? styles.open : styles.closed}`}>
            <img src={centerImg} alt="" />
          </div>

          <div className={`${styles.rightPiece} ${open ? styles.open : styles.closed}`}>
            <img src={rightImg} alt="" />
          </div>

          <div className={`${styles.contents} ${open ? styles.contentsVisible : styles.contentsHidden}`}>
            <div className={styles.heading}>
              <h1 className="font-adventuring">We use cookies to improve your experience</h1>
            </div>

            <div className={styles.boardbtn}>
              <div className={styles.boardbtnn}>
                <img
                  src={buttombord}
                  alt=""
                  role="button"
                  onClick={handleAccept}
                  style={{ cursor: loading ? 'wait' : 'pointer' }}
                />
                <h2 className="font-adventuring">Accept All</h2>
              </div>

              <div className={styles.boardbtnn}>
                <img
                  src={buttombord}
                  alt=""
                  role="button"
                  onClick={handleManagePreferences}
                  style={{ cursor: 'pointer' }}
                />
                <h4 className="font-adventuring">Manage <br />Preferences</h4>
              </div>

              <div className={styles.boardbtnn}>
                <img
                  src={buttombord}
                  alt=""
                  role="button"
                  onClick={handleReject}
                  style={{ cursor: loading ? 'wait' : 'pointer' }}
                />
                <h5 className="font-adventuring">Strictly Essential</h5>
              </div>
            </div>

            <div className={styles.heading}>
              <h3 className="font-adventuring">You can manage your preferences at any time</h3>
            </div>
          </div>
        </div>
      </div>

      {/* MANAGE PREFERENCES MODAL */}
      {showModal && (
        <div className={styles.modalOverlay}>
          {/* <button
            className={styles.closeButton}
            onClick={() => setShowModal(false)}
            aria-label="Close modal"
          >
            ×
          </button> */}

          <button
            className={styles.closeButton}
            onClick={() => setShowModal(false)}
            aria-label="Close modal"
          >
            <svg
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"x
              strokeLinecap="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
            <img src={modalBg} alt="" className={styles.modalBgImg} />
            <img src={modalBgmobile} alt="" className={styles.modalBgImgmob} />


            <div className={styles.modalContentWrapper}>
              <div className={styles.titleBoard}>
                <img src={boardImg} alt="" className={styles.boardImgTitle} />
                <h1 className="font-adventuring">Manage<br />Preferences</h1>
              </div>

              <div className={styles.cookieOptionsWrapper}>
                <div className={styles.cookieRow}>
                  <div className={styles.cookieText}>
                    <h3 className="font-adventuring">Strictly Necessary Cookies</h3>
                    <p>These cookies are required for the website to function properly. They cannot be turned off.</p>
                  </div>
                  <div className={styles.toggleSwitch}>
                    <input
                      type="checkbox"
                      checked={strictly}
                      disabled
                      className={styles.toggleInput}
                    />
                  </div>
                </div>

                <div className={styles.divider}></div>

                <div className={styles.cookieRow}>
                  <div className={styles.cookieText}>
                    <h3 className="font-adventuring">Analytical Cookies</h3>
                    <p>These cookies help us understand how visitors interact with our website so we can improve performance. All data is collected in an aggregated and anonymous form.</p>
                  </div>
                  <div className={styles.toggleSwitch}>
                    <input
                      type="checkbox"
                      checked={analytical}
                      onChange={(e) => setAnalytical(e.target.checked)}
                      className={styles.toggleInput}
                    />
                  </div>
                </div>

                <div className={styles.divider}></div>

                <div className={styles.cookieRow}>
                  <div className={styles.cookieText}>
                    <h3 className="font-adventuring">Advertising and Marketing Cookies</h3>
                    <p>These cookies are used to measure advertising effectiveness and show relevant Jungle Morals content and ads on platforms such as Google and Meta.</p>
                  </div>
                  <div className={styles.toggleSwitch}>
                    <input
                      type="checkbox"
                      checked={advertising}
                      onChange={(e) => setAdvertising(e.target.checked)}
                      className={styles.toggleInput}
                    />
                  </div>
                </div>
              </div>

              <p className={styles.footerText}>We do not knowingly collect personal data from children through cookies.</p>

              <div className={styles.buttonBoard}>
                <button
                  className={styles.boardButton}
                  onClick={handleSavePreferences}
                  disabled={loading}
                  style={{ cursor: loading ? 'wait' : 'pointer' }}
                >
                  <img src={boardImg} alt="" />
                  <span className="font-adventuring">
                    {loading ? 'Saving...' : 'Save and Apply'}
                  </span>
                </button>
                <button
                  className={styles.boardButton}
                  onClick={handleAccept}
                  disabled={loading}
                  style={{ cursor: loading ? 'wait' : 'pointer' }}
                >
                  <img src={boardImg} alt="" />
                  <span className="font-adventuring">Accept All</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Cookies;
